export const MAX_MOBILE_WIDTH = 768;

export const ALLOWANCES = [
  { key: 'boxRentalAllowance', title: 'Box Rental' },
  { key: 'computerRentalAllowance', title: 'Computer Rental' },
  { key: 'carAllowance', title: 'Car Allowance' },
  { key: 'mobilePhoneAllowance', title: 'Mobile Phone' },
  { key: 'perDiemAllowance', title: 'Per Diem Allowance' },
  { key: 'housingAllowance', title: 'Housing Allowance' },
];

export const MYCASTANDCREW_URL = 'https://my.castandcrew.com/';
export const PLUSTRAINING_URL = ' https://support.castandcrew.com/';
export const CUSTOMER_SUPPORT_URL =
  'https://www.castandcrew.com/support/customer-product-support/';
export const UNIVERSITYLINK = 'https://edge.castandcrew.com/learning/cc ';

export const MOBILE_ROUTES = {
  PROJECTS: '/projects',
  OFFERS: '/projects/:projectId/offers',
  APPROVAL: '/projects/:projectId/approvals',
};

export const REMEMBER_SIGNATURE_COOKIE = 'remember_signature';
export const VIEWED_TUTORIAL_OVERLAY = 'viewed_overlay_tutorial';
